{
  "notFound": "No encontramos este cuestionario.",
  "landing": {
    "title": "{{tenantName}} te invitó a completar un cuestionario de perfil",
    "intro": "El cuestionario toma unos 15 minutos: 30 temas cortos, cada uno se responde con diez controles deslizantes.",
    "autosave": "Tus respuestas se guardan conforme avanzas, así que puedes salir y retomar donde te quedaste cuando quieras.",
    "privacyNotice": "Aviso de privacidad: tus respuestas se procesan para generar tu perfil y su evaluación para {{tenantName}}. [TODO: texto final del aviso de privacidad (RGPD)]",
    "begin": "Comenzar",
    "reuseHint": "Completaste este cuestionario el {{date}}.",
    "reuse": "Usar mis respuestas anteriores",
    "startFresh": "Empezar de nuevo"
  },
  "progress": {
    "question": "Pregunta {{current}} de {{total}}",
    "jump": "Ir a la pregunta"
  },
  "swap": {
    "label": "Tema",
    "confirmTitle": "¿Cambiar de tema?",
    "confirmDescription": "Si cambias de tema, se descartan las respuestas que diste en esta página.",
    "confirm": "Cambiar de tema",
    "cancel": "Conservar este tema"
  },
  "navigation": {
    "previous": "Anterior",
    "next": "Siguiente"
  },
  "review": {
    "title": "¿Todo listo para enviar?",
    "finalAnswer": "Esta es tu respuesta final. Ya no podrás editarla después de esto.",
    "back": "Regresar",
    "submit": "Enviar"
  },
  "confirmation": {
    "title": "¡Gracias!",
    "body": "Tus respuestas se enviaron correctamente. Te avisaremos por correo cuando tu evaluación esté lista.",
    "cta": "Ir a Mis perfiles"
  },
  "revoked": {
    "title": "Esta invitación ya no está activa",
    "body": "El espacio de trabajo que la envió la retiró. Si crees que se trata de un error, ponte en contacto con la persona que te invitó.",
    "cta": "Ir a Mis perfiles"
  }
}
